import { useMemo, useRef, useEffect } from 'react';
import useSWR from 'swr';
import { useLocation } from 'react-router-dom';

const ACADEMIC_YEARS_KEY = 'academic-year/list/?skip=0&take=100&query=';

export function getCurrentAcademicYear(academicYears) {
  return academicYears?.find((year) => !year.ended);
}

export function getCurrentTerm(terms) {
  if (!terms?.length) return null;
  const now = new Date();
  return (
    terms.find((term) => {
      const startDate = new Date(term.startDate);
      const endDate = new Date(term.endDate);
      return now >= startDate && now <= endDate;
    }) || terms[0]
  );
}

export default function useCurrentAcademicTerm({
  academicYearId,
  setQuery,
} = {}) {
  const location = useLocation();
  const { data: academicYears } = useSWR(ACADEMIC_YEARS_KEY);
  const currentAcademicYear = useMemo(
    () => getCurrentAcademicYear(academicYears),
    [academicYears],
  );

  const effectiveYearId = academicYearId || currentAcademicYear?.id;
  const { data: terms } = useSWR(
    effectiveYearId
      ? `academic-year/terms/?academicYearId=${effectiveYearId}`
      : null,
  );
  const currentTerm = useMemo(() => getCurrentTerm(terms), [terms]);

  const initialLoadRef = useRef(true);

  useEffect(() => {
    if (
      initialLoadRef.current &&
      currentAcademicYear &&
      currentTerm &&
      !academicYearId &&
      setQuery &&
      !location.search
    ) {
      initialLoadRef.current = false;
      setQuery({
        academicYearId: currentAcademicYear.id.toString(),
        termId: currentTerm.id.toString(),
      });
    }
  }, [
    currentAcademicYear,
    currentTerm,
    academicYearId,
    setQuery,
    location.search,
  ]);

  return {
    academicYears,
    terms,
    currentAcademicYear,
    currentTerm,
    isLoading: !academicYears || !terms,
  };
}
